module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 11.2 10.7",
      url: __webpack_public_path__ + "img/icons.789192dd.svg#linkedin-usage",
      toString: function () {
        return this.url;
      }
    }